<script>
  export let value: string;
</script>

<label class="base-input-label">
  <input class="g-input" on:blur on:keyup bind:value {...$$restProps} />
</label>

<style lang="scss">
  .base-input-label {
    display: block;
    margin-bottom: 20px;
  }
</style>
